<script lang="ts">
	import GenericDisclosure from '$lib/components/GenericDisclosure.svelte';

	export let headline: string;
	export let sublines: Array<{
		title: string;
		href: string;
	}>;

	let open = false;
</script>

<GenericDisclosure bind:open>
	<div
		on:click={() => {
			if (sublines.length > 1) {
				open = !open;
			}
		}}
		on:keydown={(e) => {
			if (e.key === 'Enter' && sublines.length > 1) {
				open = !open;
			}
		}}
		role="button"
		tabindex="0"
		class="text-h-16 flex justify-between items-center text-left hover:text-dark-secondary"
	>
		<a href={`#${headline}`}>
			{headline}
		</a>
		{#if sublines.length > 1}
			<div
				class="w-6 h-6 flex-0 i-sprenger-chevron-down transform transition duration-300"
				class:rotate-180={open}
			></div>
		{/if}
	</div>
	<div class="text-p-14 gap-y-8 mt-8 flex flex-col" slot="content-open">
		{#each sublines as subline}
			<a class="text-left" href={`#${subline.href}`}>
				{subline.title}
			</a>
		{/each}
	</div>
</GenericDisclosure>
